/**
 * CLE-3015 PR 4 — the knowledge check and certificate pages. No imports, so the curriculum can use them
 * without an import cycle.
 */
export const QUIZ_PATH = "/training/quiz";
export const CERTIFICATE_PATH = "/training/certificate";
